import {
    GetItemCounts,
} from "@twigsby/client-data";
import {useInfiniteForwardingBatches} from "@twigsby/client-data/lib/Wrappers/ReactQuery/Endpoints/ForwardingBatches";
import {
    PageHeader, ContentBlock,
    ContentLoader,
    FullWidthSidebar,
    InfiniteLoadTrigger, ItemRowHeader, RichEmptyState,
    useLayout
} from "@twigsby/frontend-framework";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useLocation} from "react-router-dom";
import ForwardingBatchItem from "../../Components/ForwardingBatches/ForwardingBatchItem";
import {MailBoxImage} from "../../Components/Images/MailboxImage";
import {MailboxFilter} from "../../Components/Mail/Controls/MailboxFilter";
import MailboxNavigation from "../../Components/Mail/MailboxNavigation";
import {useSite} from "../../Providers/SiteInterfaceProvider";

const ForwardingBatches = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const { isSmall, isMedium, isLarge, isXL } = useLayout();
    const { currentLocale, updatePageMeta } = useSite();

    const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const {
        status,
        data,
        error,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        dataUpdatedAt
    } = useInfiniteForwardingBatches(location.state?.status ? { status: parseInt(location.state.status)}: {});

    const mailBoxesRef = useRef<any>();
    const mailBoxNavigationRef = useRef<any>();

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
        }
    }, [dataUpdatedAt, data]);

    useEffect(() => {
        updatePageMeta({
            title: `${t('forwardingBatches.title')} - ${t('mailboxes.title')}`
        });
    }, [currentLocale]);

    return (
        <>
            <FullWidthSidebar
                ref={mailBoxesRef}
                navigationComponent={
                    <MailboxNavigation
                        ref={mailBoxNavigationRef}
                        title={t('forwardingBatches.title')}
                        addonContent={
                            <>
                                {!isLarge && (
                                    <div className={'section-navigation-header-collapsed-addon'}>
                                        <MailboxFilter />
                                    </div>
                                )}
                            </>
                        }
                    />
                }
                extraContentClass={`flex-column forwarding-batch-rows`}
            >
                {isLarge && (
                    <PageHeader title={t('forwardingBatches.title')} />
                )}

                {isSmall && (
                    <ItemRowHeader sticky={true}>
                        <div />
                        <div>{t('forwardingBatches.headings.batchId')}</div>
                        <div>{t('forwardingBatches.headings.status')}</div>
                        <div>{t('forwardingBatches.headings.lastChanged')}</div>
                        {isMedium && (
                            <div>{t('forwardingBatches.headings.address')}</div>
                        )}
                        {isLarge && (
                            <div>{t('forwardingBatches.headings.postage')}</div>
                        )}
                        {isXL && (
                            <div>{t('forwardingBatches.headings.trackingIds')}</div>
                        )}
                    </ItemRowHeader>
                )}

                <>
                    {status === "loading" ? (
                        <ContentLoader childHeight={'7em'} />
                    ) : status === "error" ? (
                        <ContentBlock error={true} title={error?.name as string} content={error?.message} extraClass={'m-md'} />
                    ) : (
                        <>
                            {data.pages?.map((group, groupIndex) => {

                                if(group.totalRecords === 0) {
                                    return (
                                        <RichEmptyState
                                            title={t('forwardingBatches.noData.title')}
                                            description={t('forwardingBatches.noData.description')}
                                            media={<MailBoxImage />}
                                        />
                                    )
                                }

                                return (
                                    group.data?.map((forwardingBatch, index) =>
                                        <ForwardingBatchItem
                                            key={`forwardingBatch${groupIndex}${index}${forwardingBatch.batchId}`}
                                            {...forwardingBatch}
                                        />
                                    )
                                )
                            }
                            )}

                            {itemCounts.total > 0 && (
                                <InfiniteLoadTrigger
                                    loaded={itemCounts.loaded}
                                    totalCount={itemCounts.total}
                                    hasNextPage={hasNextPage}
                                    fetchNextPage={fetchNextPage}
                                    isFetchingNextPage={isFetchingNextPage}
                                />
                            )}
                        </>
                    )}
                </>
            </FullWidthSidebar>

        </>
    );
};

export default ForwardingBatches;
